import trackEvent from '../../../../helpers/gtm/eventPush';
import {
  PaymentProvider,
  PaymentProviderSubType,
  Product,
} from '../../checkout/CheckoutTypes';

// @ts-ignore
const gaPageNameOrUrlPath = window?._sr?.page.name ?? window.location.pathname;

function trackUpgradeForm({ action }) {
  return trackEvent({
    category: 'upgrade',
    action,
    label: window.location.href,
  });
}

export function trackViewAdsExplained() {
  return trackUpgradeForm({ action: 'upgrade_form_early_bird_bold_explained' });
}

export function trackViewUpgradeBenefits() {
  return trackUpgradeForm({ action: 'upgrade_form_benefit' });
}

export function trackViewCompareProducts() {
  return trackUpgradeForm({ action: 'upgrade_form_compare_products' });
}

export function trackViewFaqs() {
  return trackUpgradeForm({ action: 'upgrade_form_faqs' });
}

export function trackMultiAdLink() {
  return trackEvent({
    category: 'upgrade',
    action: 'offerer_upgrade_form_multi_ad_packages',
    label: window.location.href,
  });
}

export function trackProCommerceAppRendered() {
  return trackEvent({
    category: 'pro commerce app',
    action: 'rendered',
    non_interaction: true,
  });
}

export function trackFindOutMore() {
  return trackEvent({
    category: 'upgrade',
    action: 'upgrade_form_78',
    label: 'find_out_more',
  });
}

export function trackTiledCheckoutSelect({ label }) {
  return trackEvent({
    category: 'upgrade',
    action: 'offerer_upgrade_form_select_upgrade',
    label,
  });
}

export function trackPromoCodeCheckout({ label }) {
  return trackEvent({
    category: 'upgrade',
    action: 'upgrade_form_promo_code',
    label,
  });
}

export function trackUpgradeContinueToPayment({ label }) {
  return trackEvent({
    category: 'upgrade',
    action: 'upgrade_form_continue_to_payment',
    label,
  });
}
export function trackUpgradeFormSelectOption({ label }) {
  return trackEvent({
    category: 'upgrade',
    action: 'upgrade_form_select_option',
    label,
  });
}

export function trackPauseAnyTimeSellingPoint() {
  return trackEvent({
    category: 'upgrade',
    action: 'my_account_pause_your_upgrade',
  });
}

export function trackViewSuccessGaurenteeExpandedText() {
  return trackEvent({
    category: 'upgrade',
    action: 'success_guaranteed',
    label: gaPageNameOrUrlPath,
  });
}

export function trackOurGuaranteeLink() {
  return trackEvent({
    category: 'upgrade',
    action: 'our_guarantee',
    label: gaPageNameOrUrlPath,
  });
}
export function trackFindOutMoreGuaranteeLink() {
  return trackEvent({
    category: 'upgrade',
    action: 'success_guarantee_find_out_more',
    label: gaPageNameOrUrlPath,
  });
}

export function trackPayPalDisplay() {
  return trackEvent({
    category: 'upgrade',
    action: 'paypal_pay_option_view',
    label: window.location.href,
    non_interaction: true,
  });
}

export function trackPayPalOrder() {
  return trackEvent({
    category: 'purchase',
    action: 'paypal_pay_select',
    label: window.location.href,
  });
}

export function trackWalletDisplay(wallet_type) {
  wallet_type = wallet_type.split(' ').join('_');
  return trackEvent({
    category: 'upgrade',
    action: `${wallet_type}_option_view`,
    label: window.location.href,
    non_interaction: true,
  });
}

export function trackWalletPayment(wallet_type) {
  wallet_type = wallet_type.split(' ').join('_');
  return trackEvent({
    category: 'purchase',
    action: `${wallet_type}_select`,
    label: window.location.href,
  });
}

export function trackPaymentFailure({
  productsArray,
  paymentProvider,
  paymentProviderSubType,
  timeStamp,
}: {
  productsArray: Product[];
  paymentProvider: PaymentProvider;
  paymentProviderSubType?: PaymentProviderSubType;
  timeStamp: number;
}) {
  const tracking_label = `product=${productsArray
    .map((product) => product.id)
    .join(',')}|method=${paymentProviderSubType ||
    (paymentProvider == 'stripe' ? 'card' : paymentProvider)}|time=${new Date(
    timeStamp,
  ).toUTCString()}`;
  return trackEvent({
    category: 'Form error',
    action: 'purchase_error',
    label: tracking_label,
  });
}
